import { render, staticRenderFns } from "./DateFieldsSection.vue?vue&type=template&id=2fdeb820&scoped=true&"
import script from "./DateFieldsSection.vue?vue&type=script&lang=js&"
export * from "./DateFieldsSection.vue?vue&type=script&lang=js&"
import style0 from "./DateFieldsSection.vue?vue&type=style&index=0&id=2fdeb820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdeb820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VCombobox,VRow,VSelect})
